import imageIcon from "core/assets/images/products";
import imageCareers from "core/assets/images/base/careers.webp";

const data = {
  Header: {
    title: "Help millions of Gojek customers solve their daily frictions",
    description:
      "Millions of driver partners have increased their income with Gojek. Now is your turn!",
    image: imageCareers,
  },
  More: [
    {
      image: imageIcon.goride,
      description: "Ride your customers on safe and steady two-wheelers.",
      button: "Register",
      link: "https://blba",
    },
    {
      image: imageIcon.gocar,
      description: "Drive the four-wheeler for comfortable trips.",
      button: "Register",
      link: "https://blba",
    },
    {
      image: imageIcon.gosend,
      description: "Deliver packages safely and quickly.",
      button: "Register",
      link: "https://blba",
    },
    {
      image: imageIcon.gobox,
      description: "Help customers move heavy items.",
      button: "Register",
      link: "https://blba",
    },
  ],
};

export default data;
